<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <form @submit.prevent="reset" class="vx-col w-11/12 md:w-3/5 lg:w-2/5 sm:m-0 m-4">
      <vx-card class="rounded p-5 sm:p-10 sm:px-20 w-full">
        <div class="vx-card__title mb-10">
          <h4 class="text-center text-3xl sm:text-4xl mb-4">Reset Password</h4>
        </div>
        <div>
          <ResponseAlert ref="response" />
          <div class="vx-col w-full relative my-3">
            <vs-input 
                ref="password"
                v-validate="'required|min:8'" 
                label="New Password" 
                name="new password" 
                icon-no-border
                icon="icon icon-lock"
                icon-pack="feather"
                :type="vars.type.password"
                v-model="models.newPassword" 
                class="w-full"/>
            <vs-icon icon-pack="feather" @click="togglePassword('password')" icon="icon icon-eye" class="absolute cursor-pointer" style="top: 34px; right: 10px"></vs-icon>

            <span class="text-danger text-sm" v-show="errors.has('new password')">{{ errors.first('new password') }}</span>
          </div>

          <div class="vx-col w-full relative">
            <vs-input 
                v-validate="'required|min:8|confirmed:password'" 
                label="Password Confirmation" 
                name="password confirmation" 
                icon-no-border
                icon="icon icon-lock"
                icon-pack="feather"
                data-vv-as="password"
                :type="vars.type.confirm_password"
                v-model="vars.confirm_password" 
                class="w-full"/>
            <vs-icon icon-pack="feather" @click="togglePassword('confirm_password')" icon="icon icon-eye" class="absolute cursor-pointer" style="top: 34px; right: 10px"></vs-icon>

            <span class="text-danger text-sm" v-show="errors.has('password confirmation')">{{ errors.first('password confirmation') }}</span>
          </div>

          <vs-button button="submit" class="w-full mt-10">Save</vs-button>
        </div>
      </vx-card>
    </form>
  </div>
</template>

<script>
export default{
  data() {
    return {
      models: {
        resetPasswordToken: this.$route.query.token,
        newPassword: ''
      },
      vars: {
        type: {
          password: 'password',
          confirm_password: 'password'
        },
        confirm_password: ''
      }
    }
  },
  methods: {
    togglePassword(type) {
      this.vars.type[type] = this.vars.type[type] === 'password' ? 'text' : 'password'
    },
    reset(){
      this.$validator.validate().then(valid => {
        if (valid) {
          this.$axios.post('auth/reset-password', this.models)
          .then(() => {
						this.$showToast('Success', `Success reset password`)
            this.$router.push('/login')
          })
          .catch(error => this.$refs.response.setResponse(error.response.data, 'danger'));
        }
      });
    },
  },
  created() {
    if(!this.$route.query.token) {
      this.$router.push('/login')
    }
  }
}
</script>
